import _compact from 'lodash/compact';
import _chunk from 'lodash/chunk';
import _map from 'lodash/map';

import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';
import urlTool from '@/tools/url';

/**
 * Получаем ID вариантов товаров из корзины по ID товаров
 * @param {Array} ids - массив с ID товаров
 * @param {Map} cartIdsMap - объект с ID товаров из корзины
 *
 * @return {String} - строка с ID вариантов товаров
 */
function getVariantIdsByProductIds(ids, cartIdsMap) {
  if (!cartIdsMap || cartIdsMap.length) { return; }

  const filteredCartVariantIds = [];

  for (const [ variantId, productId ] of cartIdsMap.entries()) {
    if (ids.includes(productId)) {
      filteredCartVariantIds.push(variantId);
    }
  }

  return filteredCartVariantIds;
}

/**
 * Устанавливаем параметры для URL
 * @param {URL} path - объект URL
 * @param {Boolean} variantIds - ID вариантов для запроса из корзины
 * @param {Object} options - опции
 * 1. withoutManyVariants - флаг, указывающий на то, что нужно получить только первый вариант для каждого товара
 * 2. cartIdsMap - массив с ID вариантов товаров из корзины. В таком случае запрашиваем товары по ID вариантов
 *
 * @return {void}
 */
function setUrlSearchParams(path, variantIds, options) {
  const lang = urlTool.getKeyValue('lang') || '';

  if (lang) {
    path.searchParams.set('lang', lang);
  }

  if (variantIds && variantIds.length) {
    path.searchParams.set('with', 'variants,short_description,description,price_kinds,first_image,images,properties,characteristics,option_names,bundle_info,video_links,accessories,accessory_values,canonical_url_collection,product_field_values');

    return;
  }

  if (options.withoutManyVariants) {
    path.searchParams.set('without_many_variants', true);
  }

  path.searchParams.set('accessories', true);
}

/**
 * Сборщик задач для получения товаров с бэка
 * @param {Array} ids - массив с ID товаров
 * @param {Object} options - опции
 *
 * @return {Array} - массив с промисами
 */
export default (ids, options = {}) => {
  // Указываем, сколько id нужно отправить за раз в запросе
  const queryLimit = 25;
  const variantIds = getVariantIdsByProductIds(ids, options.cartIdsMap);

  const proccessedIds = variantIds || ids;

  /*
   * Генерим адреса для запросов
   *
   * Разбиваем на пачки, делаем из них правильные адреса для запросов
   */
  let paths = _map(_chunk(_compact(proccessedIds), queryLimit), idsList => {
    const baseUrl = window.location.origin;
    let endpoint = `/products_by_id/${idsList.join()}.json`;

    if (variantIds && variantIds.length) {
      endpoint = `/front_api/products_with_variant_ids.json?variant_ids=${idsList.join()}`;
    }

    let path = new URL(`${baseUrl}${endpoint}`);

    setUrlSearchParams(path, variantIds, options);

    return path;
  });

  // собираем задачи
  return paths.map((path) => {
    return new Promise((resolve, reject) => {
      fetchJQueryAdapter(path)
        .done(response => {
          if (response.error) {
            console.error('Products.getList. Произошла ошибка при получении товаров:', response.error);

            reject();

            return;
          }

          resolve(response);
        })
        .fail(() => {
          reject();
        });
    });
  });
};
